import { render, staticRenderFns } from "./UpdateGiftsDialog.vue?vue&type=template&id=5ef1dbec&scoped=true&"
import script from "./UpdateGiftsDialog.vue?vue&type=script&lang=js&"
export * from "./UpdateGiftsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef1dbec",
  null
  
)

export default component.exports